import { Moon, Sun } from 'lucide-react';
import { useThemePreference, type ThemePreference } from '../../hooks/useThemePreference';
import { cn } from '../../lib/utils';

const options: Array<{ theme: ThemePreference; label: string; Icon: typeof Sun }> = [
  { theme: 'dark', label: 'Dark theme', Icon: Moon },
  { theme: 'light', label: 'Light theme', Icon: Sun },
];

export default function ThemePreferenceToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useThemePreference();

  return (
    <div
      className={cn(
        'inline-grid h-9 grid-cols-2 rounded-md border border-slate-200 bg-slate-100 p-0.5 dark:border-slate-800 dark:bg-slate-900',
        className,
      )}
      role="group"
      aria-label="Theme"
    >
      {options.map(({ theme: optionTheme, label, Icon }) => {
        const active = optionTheme === theme;
        return (
          <button
            key={optionTheme}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={active}
            onClick={() => void setTheme(optionTheme)}
            className={cn(
              'inline-flex h-8 w-8 items-center justify-center rounded-[6px] text-slate-500 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400',
              active
                ? 'bg-white text-slate-950 shadow-sm dark:bg-slate-100 dark:text-slate-950'
                : 'hover:bg-white/70 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-50',
            )}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
